import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'redux-zero/react';
import { withRouter } from 'react-router';

import { actions } from '../../../shared/store.js';
import SuccessStoriesService from '../success-stories.service.js';
import { SecondaryTitle } from '../../../components/ui-toolkit/typography.js';
import SuccessStoryCard from '../success-story-card.component.js';
import NotImplemented from '../../../components/not-implemented/page-not-implemented.js';
import ScrollToTop from '../../../shared/utils.js';
import Seo from '../../../infrastructure/seo.js';

import './success-story.scss';

class SuccessStoryPageContainer extends Component {
	static prefetchData = async (language, id) => SuccessStoriesService.getOneSuccessStory({ id, language });

	static prefetchRelatedData = async language => SuccessStoriesService.getListSuccessStories({
		lang: language,
		limit: 4,
		skip: 0,
	});

	state = {
		hasError: false,
	};

	componentDidMount() {
		const {
			successStory,
			relatedSuccessStories,
			match,
			setLoading,
		} = this.props;

		ScrollToTop();
		if (
			!successStory
			|| !relatedSuccessStories
			|| match.params.storyId !== successStory.id
		) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language, match } = this.props;

		ScrollToTop();
		if (
			language.value !== prevProps.language.value
			|| match.params.storyId !== prevProps.match.params.storyId
		) {
			this.fetchData();
		}
	}

	getSuccessStoryById(storyId) {
		const { successStories } = this.props;

		if (successStories.length > 0) {
			return successStories.find(story => story.id === storyId);
		}

		return null;
	}

	fetchData() {
		const {
			match,
			language,
			setSuccessStory,
			setRelatedSuccessStories,
			setLoading,
		} = this.props;

		setLoading(true);
		SuccessStoryPageContainer.prefetchData(language.value, match.params.storyId)
			.then((data) => {
				setSuccessStory(data);
				SuccessStoryPageContainer.prefetchRelatedData(language.value)
					.then((res) => {
						setRelatedSuccessStories(
							res.filter(item => item.id !== match.params.storyId).splice(0, 3),
						);
						setLoading(false);
					})
					.catch(() => {
						setLoading(false);
						this.setState({
							hasError: true,
						});
					});
			})
			.catch(() => {
				setLoading(false);
				this.setState({
					hasError: true,
				});
			});
	}

	render() {
		const { successStory, relatedSuccessStories, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;

		if (!successStory || !relatedSuccessStories || hasError) return <NotImplemented title="Success Story" />;

		return (
			<React.Fragment>
				<Seo
					title={successStory.title}
					description={successStory.testimony}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "Review",
											"author": {
												"@type": "Person",
												"name": "${successStory.attestant}",
												"jobTitle": "${successStory.attestantJobRole}"
											},
											"reviewBody": "${successStory.testimony.replace(/\n/g, ' ')}",
											"itemReviewed": {
												"@type": "WebApplication",
												"name": "Inocrowd",
												"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
												"applicationCategory": "BusinessApplication",
												"operatingSystem": "Windows, Linux, OSX, iOS, Android",
												"provider": {
													"@type": "Organization",
													"name": "Inocrowd",
													${addresses.length > 0 && `
														"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
													`}
													${phones.length > 0 && `
														"contactPoint": {
															"@type": "ContactPoint",
															"telephone": "${phones[0].phoneNumber}",
															"contactType": "customer service"
														},
														"telephone": "${phones[0].phoneNumber}",
													`}
													${generalData && generalData.logo ? `
														"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
													` : ''}
												}
											}
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.successStories' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/success-stories"
												},
												{
													"@type": "ListItem",
													"name": "${successStory.title}",
													"position": 3,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/success-stories/${successStory.id}"
												}
											]
										}
									]
								}`}
				/>
				<div className="container container-fluid success-story">
					<div className="row">
						<div className="col-xs-12 col-md-8 col-md-offset-2">
							<div className="image-content">
								<img
									src={
										process.env.REACT_APP_API_ENDPOINT + successStory.logo.path
									}
									alt=""
								/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12 col-md-8 col-md-offset-2">
							<div
								className="description"
								dangerouslySetInnerHTML={{ __html: successStory.description }}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12 col-md-10 col-md-offset-1">
							<div className="testimony">
								<p>{successStory.testimony}</p>
								<span>
									{successStory.attestant}
									{', '}
									{successStory.attestantJobRole}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="container container-fluid more-success-stories">
					<div className="row">
						<div className="col-xs-12">
							<SecondaryTitle>
								<FormattedMessage id="success-story-details.more-success-stories" />
							</SecondaryTitle>
						</div>
					</div>
					<div className="row">
						{relatedSuccessStories
							&& relatedSuccessStories.map(item => (
								<div className="col-xs-12 col-sm-6 col-md-4" key={item.id}>
									<SuccessStoryCard story={item} flipped />
								</div>
							))}
					</div>
				</div>
			</React.Fragment>
		);
	}
}

const mapToProps = ({ language, successStory, relatedSuccessStories, addresses, phones, generalData }) => ({
	language,
	successStory,
	relatedSuccessStories,
	addresses,
	phones,
	generalData,
});

export default connect(
	mapToProps,
	actions,
)(withRouter(injectIntl(SuccessStoryPageContainer)));

export { SuccessStoryPageContainer };
